const faqs = [
  {
    q: '夫妻影院需要注册或付费吗？',
    a: '完全不需要。夫妻影院坚持免费观影理念，所有电视剧资源均免费开放，无需注册、无需登录、无需付费，打开网站即可畅快追剧。不会在任何环节向用户收取费用。',
  },
  {
    q: '播放画质如何？支持哪些清晰度？',
    a: '平台提供标清、高清720P、全高清1080P以及4K超清多种画质选择，系统会根据您的网络状况自动推荐最佳清晰度。你也可以手动切换画质，满足不同设备与网络环境需求。',
  },
  {
    q: '为什么有时候会出现缓冲？如何解决？',
    a: '缓冲通常与当前网络状况有关。建议检查WiFi信号强度，或者尝试切换到较低清晰度。平台采用智能CDN加速技术，绝大多数情况下可实现秒播不卡顿。如持续卡顿，可尝试刷新页面或更换网络环境。',
  },
  {
    q: '支持哪些设备观看？可以投屏吗？',
    a: '夫妻影院全面适配电脑、平板、手机等主流设备，浏览器打开即可使用。同时支持DLNA和AirPlay投屏功能，手机上的剧集可以一键投射到智能电视或投影仪上，享受大屏观影体验。',
  },
  {
    q: '剧集更新频率如何？新剧上线速度怎么样？',
    a: '平台每日更新30部以上剧集，热播剧集在电视台或流媒体首播后最快2小时内同步上线。国产新剧和韩剧是更新重点，周末和节假日通常有额外的新剧上架安排。',
  },
  {
    q: '遇到无法播放或画面异常怎么办？',
    a: '首先尝试切换播放线路（剧集播放页面通常提供多条线路），或者切换画质。如果问题依旧，可尝试清除浏览器缓存后刷新页面。大多数播放问题都可以通过这些简单操作解决。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于夫妻影院的使用，你可能想了解这些
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}